export default function VacancySkeleton() {
  const placeholders = Array.from({ length: 2 });

  return (
    <section>
      <div className="flex flex-col gap-6">
        {placeholders.map((_, idx) => (
          <div
            key={idx}
            className="flex-1 border rounded-lg p-5 animate-pulse flex flex-col gap-4 bg-yellow-50"
          >
            {/* Title bar */}
            <div className="h-6 bg-gray-300/70 rounded w-2/3" />

            {/* Location bar */}
            <div className="h-4 bg-gray-300/60 rounded w-1/2" />

            {/* Tag bar */}
            <div className="mt-auto h-4 bg-gray-300/50 rounded w-1/3 self-start" />
          </div>
        ))}
      </div>
    </section>
  );
}
